import { set } from 'date-fns';
import React, {useEffect, useRef, useState} from 'react'

/**
 * Benchmark component shows a line graph with values compared to industry average.
 *
 * @param {number} maxValue - The maximum value of the graph, this could come from the global maximum value from all organizations if the same industry.
 * @param {number} value - Value to be compared to the industry average.
 * @param {number} industryAverageLow - The lower average value of the industry.
 * @param {number} industryAverageHigh - The higher average value of the industry.
 * @returns
 */
export function Benchmark({
    children,
    className = '',
    maxValue = 100,
    numSteps = 6,
    industryAverageLow = 30,
    industryAverageHigh = 50,
    value = 35,
  }) {

  const [maxVal, setMaxVal] = useState(maxValue);
  const [positions, setPositions] = useState({
    low: 0,
    high: 0,
    val: 0,
    height: 0
  });

  useEffect(() => {
    setMaxVal((Math.ceil(maxValue / 10) * 10));
  }, [maxValue]);

  useEffect(() => {
    setPositions({
      low: Math.round(industryAverageLow / maxVal * 100),
      high: Math.round(industryAverageHigh / maxVal * 100),
      val: Math.round(value / maxVal * 100),
      height: Math.round(((industryAverageHigh - industryAverageLow) / maxVal) * 100),
    });
  }, [value, maxVal, industryAverageLow, industryAverageHigh]);

  function printValues() {
    let numbers = [];
    // round upward to nearest 10, -1 steps because we always include both 0 and the maxvalue
    const step = maxVal <= 20 ? 5 : (Math.ceil(maxVal / 10) * 10) / (numSteps - 1);

    for (let i = 0; i <= maxVal; i += step) {
      numbers.push(<span className="leading-none" key={`num${i}`}>{i}</span>);
    }

    return numbers.reverse();
  }

  return (
    <div className="flex flex-col items-center w-1/2 max-h-full justify-stretch h-96">
        <p className="pb-4">Compared to industry</p>
        <div className="relative flex flex-col items-stretch h-full">

            {/* div with numbers evenly spaced */}
            <div
              className="absolute flex flex-col items-center justify-between left-[50%] translate-x-[-3em] h-full"
              style={{height: "calc(100% + 1em)", top: "-.5em"}}
            >
                {printValues()}
            </div>

            {/* gray line centered  */}
            <div className="w-1 h-full bg-slate-light">&nbsp;</div>

            {/* bigger line representing industry values */}
            <div
              className="w-6 absolute bg-slate-light left-[50%] translate-x-[-50%]"
              style={{bottom: positions.low + '%', height: positions.height + '%'}}
            >&nbsp;</div>

            {/* black line representing our value, origin is top left so translate down to make it centered vertically */}
            <div
              className="absolute w-8 h-2 bg-black rounded left-[50%] translate-x-[-50%] translate-y-[50%]"
              style={{bottom: positions.val + '%'}}
            >&nbsp;</div>

            {/* text representing high and low of industry */}
            <div className="absolute flex flex-col left-[50%] translate-x-[2em] h-full">
                <span className={`absolute inline-block translate-y-[-50%] leading-none mb-[-1em]`} style={{bottom: positions.high + '%'}}>High</span>
                <span className={`absolute inline-block translate-y-[-50%] leading-none mb-[-1em]`} style={{bottom: positions.low + '%'}}>Low</span>
            </div>


        </div>
    </div>
    )
}